import { useEffect, useState } from "react";
import { getLedger } from "../../../shared/services/servicesv2";
import { LedgerListResponse } from "src/shared/types";

const useLedgers = (page: number, limit: number, searchdata?: string, field?: string, orderby?: string, osbNull?: boolean) => {
  const [ledgers, setLedgers] = useState<LedgerListResponse>();
  const [loading, setLoading] = useState(false);

  const fetchLedgers = () => {
    setLoading(true);
    getLedger(page, limit, searchdata, field, orderby, osbNull ?? false)
      .then((res) => {
        setLedgers(res.data);
      })
      .catch((error) => {
        console.error(error);
        setLedgers(undefined);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    // ✅ Debounce search calls (500 ms)
    const delay = setTimeout(() => {
      fetchLedgers();
    }, 500);

    return () => clearTimeout(delay);
    // Include all dependencies that affect fetch
  }, [page, limit, searchdata, field, orderby, osbNull]);

  return { ledgers, loading, refetch: fetchLedgers };
};

export default useLedgers;
